import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import financingBff from '~/services-v2/financial-bff/financial-bff'

export type { Partner } from '~/services-v2/financial-bff/financial-bff'

export default function usePartner(partnerId: Ref<string>) {
  const queryKey = ref(queryKeys.PARTNERS.DETAILS(partnerId.value))

  const queryFn = async () => {
    if (partnerId.value) {
      const res = await financingBff('query')({
        partner: [{
          partnerId: partnerId.value,
        }, {
          id: true,
          corporate_name: true,
          sfplus: {
            level: true,
            is_level_black: true,
          },
          blocklist: {
            is_blocked: true,
            description: true,
            title: true,
            nature: true,
            action: true,
          },
          registration_type: true,
        }],
      })

      return res.partner
    }
  }

  watch(partnerId, (_partnerId) => {
    if (partnerId.value)
      queryKey.value = queryKeys.PARTNERS.DETAILS(_partnerId)
  }, { deep: true })

  return useQuery({
    queryFn,
    queryKey,
    staleTime: 1000 * 60 * 1, // 1 minutes
    enabled: computed(() => !!partnerId.value),
  })
}

export type UsePartnerData = ReturnType<typeof usePartner>['data']
